/* eslint-disable import/no-cycle */
import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import { StorageHelper } from '../utils/StorageHelper';
import api from '../api/api';
// import api from '../api/ax';

const parametros = {
  view: StorageHelper.getOrigin(),
};

const TarjetaService = {
  sinTarjeta: (url: string) => trackPromise(api.post(url)),
  getTarjeta: () =>
    trackPromise(
      api.post(
        '/rest/tarjetas/get/tarjeta/usuario',
        JSON.stringify(parametros),
      ),
    ),
  getTipoUsuarioTarjeta: () =>
    trackPromise(api.post('/rest/tarjetas/get/tipo/tarjeta/usuario')),
  getTiposVia: () => trackPromise(api.post('/rest/tarjetas/get/tipoVia')),
  getTipoUsuarioTarjetaOro: () =>
    trackPromise(api.post('/rest/tarjetas/get/tipo/tarjeta/usuariooro')),
  getTipoUsuarioOro: () =>
    trackPromise(api.post('/rest/tarjetas/get/tipo/usuariooro')),
  solicitarTarjetaOro: (data: object) =>
    trackPromise(
      api.put(
        `/rest/tarjetas/${i18next.language}/solicitar/tarjetaoro`,
        JSON.stringify(data),
      ),
    ),
  solicitarTarjPago: () =>
    trackPromise(
      api.get(`/rest/tarjetas/${i18next.language}/solicitar/tarjetapago`),
    ),
  solicitarToken: () =>
    trackPromise(api.get(`/rest/tarjetas/${i18next.language}/token/getAccess`)),
  eventoAltaTarjetaOro: (data: object) =>
    trackPromise(
      api.post(
        `/rest/tarjetas/${i18next.language}/solicitar/eventotarjetaoro`,
        JSON.stringify(data),
      ),
    ),
  completarDatosTarjetaOro: (data: object) =>
    trackPromise(
      api.put(
        `/rest/tarjetas/${i18next.language}/completar/datos/tarjetaoro`,
        JSON.stringify(data),
      ),
    ),
  getPaisesOro: () =>
    trackPromise(api.post('/rest/tarjetas/get/paises/tarjetaoro')),
  cambiarCuotaTarjetaOro: (data: object) =>
    trackPromise(
      api.put(
        `/rest/tarjetas/${i18next.language}/cambiar/cuota/tarjetaoro`,
        JSON.stringify(data),
      ),
    ),
  getCuotasPendientesOro: () =>
    trackPromise(
      api.post(
        `/rest/tarjetas/${i18next.language}/get/cuotas/pendientes/tarjetaoro`,
      ),
    ),
  getInfoUsuarioOro: () =>
    trackPromise(
      api.post(`/rest/tarjetas/${i18next.language}/get/info/usuariooro/`),
    ),
  getCuotaTarjetaOro: () =>
    trackPromise(api.post('/rest/tarjetas/get/cuota/usuariooro')),
  cambiarCuentaTarjetaOro: (data: object) =>
    trackPromise(
      api.put(
        `/rest/tarjetas/${i18next.language}/cambiar/cuenta/tarjetaoro`,
        JSON.stringify(data),
      ),
    ),
  requestNewCard: (data: object) =>
    trackPromise(
      api.put(
        '/rest/tarjetas/solicitar/tarjeta/duplicada',
        JSON.stringify(data),
      ),
    ),
  solicitarBajaOro: () =>
    trackPromise(
      api.put(`/rest/tarjetas/${i18next.language}/solicitar/baja/tarjetaoro`),
    ),
  getAdicionalesInfo: (data: object) =>
    trackPromise(
      api.post('/rest/tarjetas/get/info/adicionales', JSON.stringify(data)),
    ),
  requestNewCardForAdditional: (data: object) =>
    trackPromise(
      api.put(
        '/rest/tarjetas/solicitar/tarjeta/duplicada-adicional',
        JSON.stringify(data),
      ),
    ),
  abonarImpagos: (key: string) =>
    trackPromise(
      api.post(
        `/rest/tarjetas/${i18next.language}/abonar/impagos/${key}`,
        JSON.stringify(parametros),
      ),
    ),
};

export default TarjetaService;
